<script>
import Evaluate from '@/core/evaluate/evaluate';
import { evaluate, getRecycleNum } from '@/apis/base';
import hButton from '@/components/button';
import { Toast } from 'mint-ui';
import productInfo from '@/core/evaluate/product-info';

export default {
  components: {
    Evaluate,
    hButton,
    productInfo
  },
  props: {
    selecteds: String
  },
  data () {
    return {
      loading: false,
      selects: [],
      recycleNum: 0
    };
  },
  computed: {
    requiredLen () {
      return this.params.itemList && this.params.itemList.filter(item => item.conftype !== '3').length;
    },
    isCompleted () {
      return this.selects.length >= this.requiredLen;
    },
    params () {
      return this.$store.state.productParam.params;
    },
    productId () {
      return this.params.productId;
    },
    loaded () {
      return this.params.productName;
    }
  },
  methods: {
    reselect () {
      this.$router.push('/products');
    },
    async getRecycleNum () {
      try {
        if (!this.productId) {
          Toast('机型选择有误，请重新选择');
          return;
        }
        const res = await getRecycleNum(this.productId);

        if (res.success) {
          this.recycleNum = res._data.recycleNum;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async submit (isReport) {
      if (!this.isCompleted) {
        return;
      }
      /* eslint-disable */
      const { bd_vid } = this.$route.query;
      if (bd_vid) {
        this.$store.commit('report/reportHandle', {
          event: 'hsbbaidusem',
          custom: {
            iconName: '立即估价',
            bd_vid,
            sku: this.loaded
          }
        });
      }
      /* eslint-disable */
      // 自有PC立即估价上报
      if (isReport) {
        this.$store.commit('report/reportHandle', { event: 'qucikEvaluation' });
      }
      this.loading = true;
      let res = null;
      try {
        res = await evaluate(this.productId, JSON.stringify(this.selects));
      } catch (err) {
        console.log(err);
      }
      if (!res || +res._errCode !== 0) {
        this.loading = false;
        Toast(res._errStr || 'error');
        return;
      }
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      this.$router.push({
        name: 'EvInfo',
        params: {
          evID: res._data.evaluateid
        },
        query: {
          selecteds: JSON.stringify(this.selects)
        }
      });
    },
    init () {
      this.getRecycleNum();
      const selecteds = this.$route.query.selecteds;
      if (!selecteds) {
        return;
      }
      try {
        this.selects = JSON.parse(selecteds);
      } catch (err) {
        console.log(err);
      }
    }
  },
  beforeMount () {
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/core/evaluate/index.vue